import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CameraSvg = function CameraSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 9.335c-.966 0-1.893.37-2.577 1.028a3.45 3.45 0 0 0-1.067 2.482c0 .93.384 1.824 1.067 2.482A3.72 3.72 0 0 0 12 16.355c.966 0 1.893-.37 2.577-1.028a3.45 3.45 0 0 0 1.067-2.482c0-.931-.384-1.824-1.067-2.482A3.72 3.72 0 0 0 12 9.335m-1.618 1.951A2.33 2.33 0 0 1 12 10.641c.607 0 1.189.232 1.618.645s.67.974.67 1.559c0 .584-.24 1.145-.67 1.558A2.33 2.33 0 0 1 12 15.05a2.33 2.33 0 0 1-1.618-.646 2.16 2.16 0 0 1-.67-1.558c0-.585.24-1.145.67-1.559",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.766 4H8.234L6.116 7.265H2V20h20V7.265h-4.116zM6.867 8.571l2.119-3.265h6.028l2.119 3.265h3.511v10.123H3.356V8.57z",
    clipRule: "evenodd"
  }));
};
export var Camera = function Camera(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CameraSvg
  }));
};